import Events from './events';
import { baseInfo, interactive, report } from './native/index';
import webMethods from './web/index';

const IS_IN_APP = typeof grounds !== 'undefined';

const externalCallHandler = ({ name, fullName, args }) => {
    if (webMethods[name]) {
        return webMethods[name](...args);
    }

    console.warn(`在外部环境调用了客户端方法：${fullName || name}()`);

    return new Proxy(
        {},
        {
            get: (target, property, receiver) => {
                return externalCallHandler.bind(null, {
                    name: property,
                    fullName: `${name}().${property}`,
                    args,
                });
            },
        },
    );
};

const addMethods = methods => {
    return target => {
        Object.keys(methods).forEach(item => {
            target.prototype[item] = (...args) => {
                if (!IS_IN_APP) {
                    return externalCallHandler({
                        name: item,
                        args,
                    });
                } else {
                    return methods[item](...args);
                }
            };
        });
    };
};

@addMethods(report)
@addMethods(baseInfo)
@addMethods(interactive)
class Grounds {
    constructor() {
        // 监听webview被挂起（一般是app被放到后台的情况下）
        this.on('exit', () => {
            console.log('exit');
            this.trigger('exit');
        });

        // 监听webview被激活
        this.on('active', () => {
            console.log('active');
            this.trigger('active');
        });
    }
}

Events.mixTo(Grounds);

export default new Grounds();
